import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { getDetergentHistory, updateDetergentHistory } from '@/apis/detergentHistories'
import useNotification from '@/hooks/useNotification'
import { GetDetergentHistoryRequest } from '@/types/apis/detergentHistories/GetDetergentHistoryRequest'
import { GetDetergentHistoryResponse } from '@/types/apis/detergentHistories/GetDetergentHistoryResponse'
import { UpdateDetergentHistoryRequest } from '@/types/apis/detergentHistories/UpdateDetergentHistoryRequest'
import { UpdateDetergentHistoryResponse } from '@/types/apis/detergentHistories/UpdateDetergentHistoryResponse'

export const useUpdateDetergentHistories = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateDetergentHistoryResponse>()

  const update = useCallback(
    async (request: UpdateDetergentHistoryRequest) => {
      try {
        setLoading(true)
        const res = await updateDetergentHistory(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [openNotification, t]
  )

  return {
    loading,
    updateDetergentHistory: update,
    response,
  }
}

export const useGetDetergentHistory = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetDetergentHistoryResponse>()

  const get = useCallback(async (request: GetDetergentHistoryRequest) => {
    try {
      setLoading(true)
      const res = await getDetergentHistory(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getDetergentHistory: get,
    response,
  }
}
